module.exports = __webpack_public_path__ + "img/features.ea5537e3.png";